import {inject, Injectable} from '@angular/core';
import {TableColumnCheckboxService} from "./table-column-checkbox.service";
import {ConfirmService} from "../../../services/confirm.service";
import {RecordTableDataService} from "./record-table-data.service";
import {RecordsDataRequestQueryParamsService} from "./records-data-request-query-params.service";
import {RecordsTableService} from "../../../services/records-table.service";
import {RecordTableAction} from "../../../types/record-table-action.types";
import {
  RecordData, RecordTableColumnParams,
  RecordTotalData,
  RecordUpdateParams,
  RecordUpdateRequestParams
} from "../../../types/records-table.types";
import {DeleteConfirmationParams} from "../../../types/confirmation-modal.types";
import {defaultDeleteConfirmationParams} from "../../../models/default-delete-confirmation-params";
import {defaultRecordData} from "../../../models/default-record-data";
import {Pageable} from "../../../types/pagable.types";

@Injectable({
  providedIn: 'root'
})
export class RecordsTableContainerService {
  private tableColumnCheckBoxService: TableColumnCheckboxService = inject(TableColumnCheckboxService);
  private confirmService: ConfirmService = inject(ConfirmService);
  private recordTableDataService: RecordTableDataService = inject(RecordTableDataService);
  private recordsDataRequestQueryParamsService: RecordsDataRequestQueryParamsService = inject(RecordsDataRequestQueryParamsService);
  private recordsTableService: RecordsTableService = inject(RecordsTableService);

  public async getRecordsTableData(path: string): Promise<Pageable<RecordData>> {
    return await this.recordTableDataService.getRecordsTableData({
      path: path,
      queryParams: this.recordsDataRequestQueryParamsService.recordsDataRequestQueryParamsState()
    });
  }

  public async getRecordsTotalData(path: string, recordsTableActions: Array<RecordTableAction>): Promise<Array<RecordTotalData>> {
    return await this.recordTableDataService.getRecordsTotalData({
      path: path,
      queryParams: this.recordsDataRequestQueryParamsService.recordsDataRequestQueryParamsState(),
      recordsTableActions: recordsTableActions
    });
  }

  public setColumnCheckboxState(recordsTableData?: Array<RecordData>): void {
    const recordIds = recordsTableData?.map(record => Number(record.id)) || [];
    this.tableColumnCheckBoxService.setColumnCheckboxState(recordIds);
  }

  public async isDeleteConfirmed(recordId: string | number): Promise<boolean> {
    const deleteConfirmationParams: DeleteConfirmationParams = {
      ...defaultDeleteConfirmationParams,
      description: `Вы уверены, что хотите удалить запись №${recordId}?`
    };

    return await this.confirmService.getDeleteConfirmation(deleteConfirmationParams);
  }

  public async updatedRecordField(recordUpdateParams: RecordUpdateParams, path: string): Promise<RecordData> {
    const showMistakes = this.recordsDataRequestQueryParamsService.recordsDataRequestQueryParamsState().showMistakes;
    const recordUpdateRequestParams: RecordUpdateRequestParams = {
      path: path,
      ...(showMistakes && { showMistakes: true }),
      ...recordUpdateParams
    };

    return await this.recordsTableService.updatedRecordField<RecordData>(recordUpdateRequestParams).catch(() => defaultRecordData);
  }

  public hasFilterableColumns(columnsParams: Array<RecordTableColumnParams>): boolean {
    return columnsParams.some((param: RecordTableColumnParams) => param.filterable);
  }
}
